import yaml from 'js-yaml';
import { PortfolioConfig } from '../types/config';

export const loadConfig = async (): Promise<PortfolioConfig> => {
  try {
    const response = await fetch('/config.yaml');
    const yamlText = await response.text();
    const config = yaml.load(yamlText) as PortfolioConfig;
    
    // Override sensitive data with environment variables if available
    if (process.env.REACT_APP_FORM_ACCESS_KEY) {
      config.contact.formAccessKey = process.env.REACT_APP_FORM_ACCESS_KEY;
    }
    
    return config;
  } catch (error) {
    console.error('Error loading config:', error);
    throw new Error('Failed to load portfolio configuration');
  }
};

/**
 * Extract unique categories from skills data
 * @param skills Array of skills with category property
 * @returns Array of unique category names, sorted alphabetically
 */
export const extractCategories = (skills: Array<{ category: string }>): string[] => {
  return Array.from(
    new Set(skills.map(skill => skill.category))
  ).sort();
}; 